import { forwardRef } from 'react';

import { Heading, type HeadingProps } from '../heading/heading';

export const PanelHeading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ level = 3, noWrap = true, ...rest }, ref) => (
    <Heading slot="title" ref={ref} level={level} noWrap={noWrap} {...rest} />
  ),
);
